import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={22.663} height={20} {...props}>
    <defs>
      <radialGradient id="b" cx={0.5} cy={0.5} r={0.5} gradientUnits="objectBoundingBox">
        <stop offset={0.27} stopColor="#000c18" />
        <stop offset={0.82} stopColor="#1a4e5b" />
        <stop offset={1} />
      </radialGradient>
      <linearGradient
        id="a"
        x1={0.271}
        y1={0.211}
        x2={0.741}
        y2={0.804}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#d5d1d2" />
        <stop offset={0.14} stopColor="#8e8788" />
        <stop offset={0.44} stopColor="#dbdbdb" />
        <stop offset={0.78} stopColor="#a6a2a2" />
        <stop offset={0.91} stopColor="#cccaca" />
      </linearGradient>
    </defs>
    <g data-name="Racing 20" transform="translate(-.623 -18.17)">
      <path
        data-name="Path 5794"
        d="M22.725 27.726c0-.073-.008-.146-.013-.218a9.248 9.248 0 0 0-8.642-8.591 57.17 57.17 0 0 0-2.229-.088c-2.338-.05-4.683.012-7.023 0-.143 0-.919.083-.91.751a.912.912 0 0 0 .474.6 2.065 2.065 0 0 0 .847.083c.906.008 1.813 0 2.813 0l-.083.1A5.9 5.9 0 0 1 6.4 21.698a4.607 4.607 0 0 1-2.183.348c-.795.016-1.668-.017-2.5-.024-.52 0-1.069.03-1.088.678-.021.724.574.731 1.114.73h3.373a9.551 9.551 0 0 0 .441 10.149h-.023a11.91 11.91 0 0 0-1.9.03c-.288.049-.784.264-.784.619s.479.668.771.724a6.344 6.344 0 0 0 1.895.026 2.6 2.6 0 0 1 1.418.189 3.323 3.323 0 0 1 1.114.87l.036.042H1.637c-.513 0-1.017.178-.9.746a1.164 1.164 0 0 0 .889.661c3.387.019 6.779.1 10.163.014q1.146-.028 2.29-.084a9.2 9.2 0 0 0 8.611-8.293c.008-.076.014-.152.02-.228a.069.069 0 0 1 0-.012c0-.061.008-.124.012-.186v-.071c0-.064.005-.127.007-.19v-.265c0-.149 0-.3-.011-.445Zm-9.54 6.24a5.794 5.794 0 1 1 5.945-5.582 5.86 5.86 0 0 1-5.945 5.582Z"
        fill="#ffe000"
      />
      <path
        data-name="Path 7760"
        d="M23.285 28.17V28.453c0 .068 0 .134-.008.2v.075c0 .066-.008.132-.013.2v.013l-.022.241a10 10 0 0 1-16.671 6.392 10 10 0 1 1 16.7-8.1c.005.077.011.153.014.231.008.156.011.313.011.47Z"
        fill="#ffe000"
      />
      <circle
        data-name="Ellipse 227"
        cx={6.923}
        cy={6.923}
        r={6.923}
        transform="translate(6.28 21.653)"
        fill="url(#a)"
      />
      <path
        data-name="Path 7761"
        d="M67.73 40.846c0-.069-.007-.137-.012-.206a8.926 8.926 0 1 0-14.9 7.232 8.906 8.906 0 0 0 4.582 2.207 8.934 8.934 0 0 0 10.3-7.912l.02-.215v-.012c0-.058.008-.117.011-.175v-.068c0-.06.005-.12.006-.18v-.247c0-.14 0-.281-.01-.419Zm-14.43.423a5.518 5.518 0 1 1 5.417 5.47 5.518 5.518 0 0 1-5.417-5.47Z"
        transform="translate(-45.53 -13.095)"
        fill="url(#b)"
      />
      <g data-name="Group 6372" fill="#011724">
        <path
          data-name="Path 5795"
          d="M17.657 27.613a4.565 4.565 0 0 1-1.346 3.726c-.327-.75-.834-1.378-.818-1.99.036-1.226.9-1.766 2.164-1.736Z"
        />
        <path
          data-name="Path 5796"
          d="M10.066 31.141a4.438 4.438 0 0 1-1.138-3.792c.693.385 1.472.572 1.818 1.062.696.99.344 1.957-.68 2.73Z"
        />
        <path
          data-name="Path 5797"
          d="M11.257 32.002c.651-.441.629-1.362 1.6-1.472a2.007 2.007 0 0 1 2.3 1.541 4.282 4.282 0 0 1-3.9-.069Z"
        />
        <path
          data-name="Path 5798"
          d="M9.434 26.075a4.407 4.407 0 0 1 3.2-2.242c-.115.762 0 1.568-.353 2.019a1.884 1.884 0 0 1-2.846.223Z"
        />
        <path
          data-name="Path 5799"
          d="M17.269 26.317a6.306 6.306 0 0 1-2.163.136c-1.161-.393-1.32-1.4-1.005-2.557a4.415 4.415 0 0 1 3.168 2.422Z"
        />
        <path
          data-name="Path 5800"
          d="M13.123 29.196a1 1 0 0 1-.916-1.041 1.028 1.028 0 0 1 1.1-1.047 1 1 0 0 1 1.016 1.044 1.056 1.056 0 0 1-1.2 1.045Z"
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;
